import { Button } from "../../../../shadcn/components/ui/button";

export default function PostYourProperty() {
  return (
    <>
      <div className="w-full p-6 lg:py-0 lg:px-[124px] mt-4 lg:mt-20  2xl:w-[1292px] 2xl:mx-auto 2xl:px-0">
        <div className="bg-brand-lightBlue justify-center min-h-[408px] lg:justify-normal pt-8 px-[22px] lg:p-10 mid:px-[62px] flex relative mid:pt-[67px] mid:pb-[66px] clip-path-bottomRightPostProperty">
          {/* Left part */}
          <div className="">
            <p className="font-spaceGrotesk font-normal lg:text-start text-center text-mobile-h2 sm:text-[40px] sm:leading-10 lg:text-web-h2 leading-9 lg:leading-[59px] text-brand-textBlack max-w-[360px] lg:max-w-[500px]">
              OUR TOOL TO HELP YOU IN BIDDING
            </p>
            <div className="flex justify-center lg:justify-normal">
              <Button
                onClick={() => {
                  if (window != undefined) {
                    window.location.href =
                      process.env.NEXT_PUBLIC_BIDDER_URL || "";
                  }
                }}
                className="w-[146px] flex h-10 lg:h-[52px] lg:w-[112px] mt-[22px] sm:mt-10 md:mt-14 lg:mt-[30px]"
              >
                <p className="font-openSans font-semibold text-mobile-body-md lg:text-web-body-lg leading-4 text-white">
                  Know More
                </p>
              </Button>
            </div>
          </div>
          {/* Right part */}
          <img
            src="/tool.png"
            className="hidden lg:flex h-[270px] mid:h-[333px] absolute right-0 bottom-0"
            alt=""
          />
          <img
            src="/toolMobile.png"
            className="lg:hidden h-[287px] sm:h-[320px] left-0 mid:h-[333px] absolute bottom-0"
            alt=""
          />
        </div>
      </div>
    </>
  );
}
